<div class="counts" *ngIf="productionSchedulingCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Prod Scheduling
        <span>{{ productionSchedulingCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'productionSchedulingCounts',
          'needsScheduled'
        ]"
      >
        <p class="count">Projects to Schedule</p>
        <span>{{ productionSchedulingCounts.needsScheduled }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'productionSchedulingCounts',
          'scheduled'
        ]"
      >
        <p class="count">Projects Scheduled</p>
        <span>{{ productionSchedulingCounts.scheduled }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'productionSchedulingCounts',
          'incompleteProject'
        ]"
      >
        <p class="count">Incomplete Projects</p>
        <span>{{ productionSchedulingCounts.incompleteProject }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'productionSchedulingCounts',
          'timeExtensionRequired'
        ]"
      >
        <p class="count">Time Extension Required</p>
        <span>{{ productionSchedulingCounts.timeExtensionRequired }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
